import React from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import debounce from 'lodash/debounce';

import { searchUsers } from './api';

export default class RemoteUserSelect extends React.Component {
  static propTypes = {
    defaultValue: PropTypes.object,
    onChange: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.debouncedloadAssigneeOptions = debounce(this.loadAssigneeOptions, 250);
  }

  loadAssigneeOptions = (inputValue, callback) => {
    searchUsers(inputValue).then(({ users }) => {
      const options = users.map(user => ({ value: user.id.toString(), label: `${user.name} (${user.email})` }));
      callback(options);
    });
  }

  render() {
    return (
      <AsyncSelect
        defaultOptions={true}
        defaultValue={this.props.defaultValue}
        loadOptions={this.debouncedloadAssigneeOptions}
        onChange={this.props.onChange}
      />
    );
  }
}
